import type { TourChapterDef } from '../types';
import { s } from './sharedSteps';

export const employeeChapters: TourChapterDef[] = [
  {
    id: 'employee.dashboard',
    titleKey: 'dashboard',
    route: '/dashboard',
    useSampleData: true,
    steps: [
      s('[data-tour="dashboard-stats"]', 'tour.ch.dashboard.stats.title', 'tour.ch.emp.dashboard.stats.body', '/dashboard', { placement: 'bottom' }),
      s('[data-tour="dashboard-earnings"]', 'tour.ch.emp.earnings.title', 'tour.ch.emp.earnings.body', '/dashboard', { placement: 'bottom' }),
      s('[data-tour="dashboard-upcoming"]', 'tour.ch.dashboard.upcoming.title', 'tour.ch.dashboard.upcoming.body', '/dashboard', { placement: 'left' }),
    ],
  },
  {
    id: 'employee.shifts',
    titleKey: 'shifts',
    route: '/shifts',
    useSampleData: true,
    steps: [
      s('[data-tour="shifts-view-toggle"]', 'tour.ch.shifts.view.title', 'tour.ch.emp.shifts.view.body', '/shifts', { placement: 'bottom' }),
      s('[data-tour="shifts-list"]', 'tour.ch.emp.shifts.list.title', 'tour.ch.emp.shifts.list.body', '/shifts', { placement: 'top' }),
    ],
  },
  {
    id: 'employee.announcements',
    titleKey: 'announcements',
    route: '/announcements',
    useSampleData: true,
    steps: [
      s('[data-tour="announcements-list"]', 'tour.ch.ann.list.title', 'tour.ch.emp.ann.list.body', '/announcements', { placement: 'right' }),
    ],
  },
  {
    id: 'employee.activity',
    titleKey: 'recent.activity',
    route: '/recent-activity',
    useSampleData: true,
    steps: [
      s('[data-tour="activity-feed"]', 'tour.ch.activity.feed.title', 'tour.ch.activity.feed.body', '/recent-activity', { placement: 'top' }),
    ],
  },
  {
    id: 'employee.my-shifts',
    titleKey: 'my.shifts',
    route: '/my-shifts',
    useSampleData: true,
    steps: [
      s('[data-tour="my-shifts-list"]', 'tour.ch.emp.myshifts.list.title', 'tour.ch.emp.myshifts.list.body', '/my-shifts', { placement: 'top' }),
      s('[data-tour="my-shifts-attendance"]', 'tour.ch.emp.myshifts.leave.title', 'tour.ch.emp.myshifts.leave.body', '/my-shifts', { placement: 'left' }),
    ],
  },
  {
    id: 'employee.vacation',
    titleKey: 'vacation',
    route: '/vacation',
    useSampleData: true,
    steps: [
      s('[data-tour="vacation-form"]', 'tour.ch.vacation.form.title', 'tour.ch.emp.vacation.form.body', '/vacation', { placement: 'right' }),
      s('[data-tour="vacation-list"]', 'tour.ch.vacation.list.title', 'tour.ch.emp.vacation.list.body', '/vacation', { placement: 'top' }),
    ],
  },
  {
    id: 'employee.my-contracts',
    titleKey: 'my.contracts',
    route: '/my-contracts',
    useSampleData: true,
    steps: [
      s('[data-tour="mycontracts-list"]', 'tour.ch.emp.contracts.list.title', 'tour.ch.emp.contracts.list.body', '/my-contracts', { placement: 'top' }),
    ],
  },
  {
    id: 'employee.my-jobs',
    titleKey: 'my.jobs',
    route: '/my-jobs',
    useSampleData: true,
    steps: [
      s('[data-tour="myjobs-list"]', 'tour.ch.myjobs.list.title', 'tour.ch.myjobs.list.body', '/my-jobs', { placement: 'top' }),
    ],
  },
  {
    id: 'employee.messages',
    titleKey: 'messages',
    route: '/messages',
    useSampleData: true,
    steps: [
      s('[data-tour="messages-contacts"]', 'tour.ch.messages.contacts.title', 'tour.ch.messages.contacts.body', '/messages', { placement: 'right' }),
      s('[data-tour="messages-thread"]', 'tour.ch.messages.thread.title', 'tour.ch.messages.thread.body', '/messages', { placement: 'left' }),
    ],
  },
  {
    id: 'employee.cv',
    titleKey: 'cv.manager',
    route: '/cv-manager',
    useSampleData: true,
    steps: [
      s('[data-tour="cv-main"]', 'tour.ch.emp.cv.title', 'tour.ch.emp.cv.body', '/cv-manager', { placement: 'top' }),
    ],
  },
  {
    id: 'employee.jobs',
    titleKey: 'job.board',
    route: '/job-board',
    useSampleData: true,
    steps: [
      s('[data-tour="jobboard-view"]', 'tour.ch.jobs.view.title', 'tour.ch.emp.jobs.view.body', '/job-board', { placement: 'bottom' }),
    ],
  },
  {
    id: 'employee.settings',
    titleKey: 'settings',
    route: '/settings?tab=preferences',
    useSampleData: true,
    steps: [
      s('[data-tour="settings-tabs"]', 'tour.ch.settings.tabs.title', 'tour.ch.settings.tabs.body', '/settings', { placement: 'bottom' }),
      s('[data-tour="settings-notifications"]', 'tour.ch.settings.prefs.title', 'tour.ch.settings.prefs.body', '/settings?tab=preferences', { placement: 'top' }),
    ],
  },
  {
    id: 'employee.help',
    titleKey: 'tour.help',
    route: '/dashboard',
    useSampleData: true,
    steps: [
      s('[data-tour="help"]', 'tour.ch.help.title', 'tour.ch.help.body', '/dashboard', { placement: 'right' }),
      s('[data-tour="replay-tour"]', 'tour.ch.help.replay.title', 'tour.ch.help.replay.body', '/settings?tab=preferences', { placement: 'top' }),
    ],
  },
];
